import { ThemeFile } from 'lib/context/ThemeContext';

export const ARProductCardTheme: ThemeFile = {
  aw: {
    classes: {},
  },
  rba: {
    classes: {
      cardWrapper: 'col-span-12 border-b border-gray p-s md:min-h-[531px] flex flex-col my-3',
      imageWrapper: 'relative mb-s flex flex-row',
      headline:
        'border-dark mb-s border-t pt-s font-sans text-sm-s font-medium md:min-h-[73px] flex flex-col items-center',
      buttonContainer:
        'mt-auto mb-s flex items-start justify-center md:flex-row md:items-center md:gap-x-4',
      buttonWrapper: 'mt-s items-center justify-center',
      buttonIcon:
        'ml-[10px] text-theme-btn-primary-icon group-hover:text-theme-btn-primary-icon-hover group-disabled:text-dark-gray',
      button:
        'group relative flex w-fit items-center bg-theme-btn-bg p-s font-serif text-button font-bold text-theme-btn-text hover:bg-theme-btn-bg-hover hover:text-theme-btn-text-hover disabled:bg-gray disabled:text-dark-gray disabled:cursor-not-allowed mr-2 !w-full md:!w-fit justify-center mr-m',
    },
  },
};
